import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { AppDispatch, GlobalState } from './store'
import { Snackbar, SnackbarProvider } from './components/common/Snackbar'
import { Login } from './components/login'
import LoggedIn from './components/loggedin'
import { init } from './redux/actions/uiActions'
import { ThemeSwitcher } from './ThemeSwitcher'
import { DocumentFavicon } from './components/common/DocumentFavicon'
import { queryClient } from './queryClient'

/**
 * Used just to add navigate to store middleware to use in redux epics
 */
const Initializer = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    dispatch(init(navigate))
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
  return null
}

function App() {
  const isLoggedIn = useSelector(
    ({ userReducer }: GlobalState) =>
      typeof userReducer.user === 'object' && !!userReducer.user && 'id' in userReducer.user,
    shallowEqual,
  )
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeSwitcher isLoggedIn={isLoggedIn}>
        <Initializer />
        <DocumentFavicon />

        <SnackbarProvider>
          <Snackbar />
          {isLoggedIn ? <LoggedIn /> : <Login />}
        </SnackbarProvider>
      </ThemeSwitcher>
    </QueryClientProvider>
  )
}

export default App
